import SectionsContainer from './SectionsContainer';

export default SectionsContainer;
